import { Box, IconButton } from '@mui/material';
import React from 'react';
// import { BasicSelect as TransLang } from './TransLang';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const iconMap = {
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    twitter: XIcon,
    linkedin: LinkedInIcon,
    youtube: YouTubeIcon,
};

const TopBar = ({ data }) => {
    const social = data?.social || {};

    return (
        <Box
            sx={{
                bgcolor: '#C59850',
                color: '#FFFFFF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: { xs: 2, md: 6 },
                py: 0.5,
                zIndex: 9999
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                {Object.entries(social).map(([key, url]) => {
                    if (!url) return null;
                    const Icon = iconMap[key.toLowerCase()];
                    if (!Icon) return null;
                    return (
                        <IconButton
                            key={key}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: '#FFFFFF', p: 0.5, '&:hover': { opacity: 0.8 } }}
                            size="small"
                        >
                            <Icon sx={{ fontSize: 18 }} />
                        </IconButton>
                    );
                })}
            </Box>
            {/* <TransLang /> */}
        </Box>
    );
};

export default TopBar;
